module.exports = __webpack_public_path__ + "img/river@2x.36ae8936.png";